import { UiSchema } from 'prove-common/rjsf'
import type { AnalysisTypeFormData } from './analysis-type-schema'

export const analysisTypeUiSchema: UiSchema<AnalysisTypeFormData> = {
  'ui:options': {
    allowWrap: true
  },
  substanceIds: {
    'ui:widget': 'multiSelectWidget'
  }
}
